export default {
  // General metadata translations
  loadingDefinitions: 'Chargement des définitions de métadonnées...',
  noDefinitionsAvailable: 'Aucune définition de métadonnées disponible pour ce type de ressource.',
  enterValue: 'Saisir une valeur',
  removeField: 'Supprimer le champ',

  // Metadata field definitions
  fields: {
    ideal_stock: {
      label: 'Stock idéal',
      description: 'Quantité idéale en stock'
    },
    critical_stock: {
      label: 'Stock critique',
      description: 'Seuil d\'alerte pour le stock'
    },
    renewal_date: {
      label: 'Date de renouvellement',
      description: 'Date prévue pour le renouvellement'
    },
    unit: {
      label: 'Unité de mesure',
      description: 'Unité de mesure pour les consommables (ex: kg, litres, pièces)'
    },
    owned_by: {
      label: 'Propriétaire',
      description: 'Utilisateur propriétaire de la ressource'
    },
    allows_participation: {
      label: 'Autoriser la Participation',
      description: 'Permet aux autres utilisateurs d\'indiquer leur participation aux emprunts de cette ressource'
    },
    reservation_managers: {
      label: 'Exiger la Validation des Réservations',
      description: 'Les réservations doivent être validées par des gestionnaires désignés avant emprunt',
      managersLabel: 'Gestionnaires de Réservation',
      addPlaceholder: 'Ajouter un gestionnaire...',
      searchPlaceholder: 'Rechercher des utilisateurs...',
      noUsersFound: 'Aucun utilisateur trouvé',
      noManagers: 'Aucun gestionnaire assigné. Ajoutez au moins un gestionnaire pour que la validation fonctionne.'
    }
  }
};
